import { Divider, Modal } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import { EmailSendStrategy, NewsletterEmailDTO } from "../../../../../../Api";

type PreviewEmailModalProps = {
	isOpen: boolean;
	onClose: () => void;
	email: NewsletterEmailDTO;
};

export const PreviewEmailModal = (props: PreviewEmailModalProps) => {
	const { t, i18n } = useTranslation();
	const { isOpen, onClose, email } = props;

	return (
		<Modal
			title={email.subject}
			open={isOpen}
			onCancel={onClose}
			footer={[]}
			width={"80%"}
		>
			<div className="overflow-y-scroll max-h-[70vh]">
				<div
					dangerouslySetInnerHTML={{ __html: email.body ?? "" }}
					className="pt-8"
				/>
				<Divider style={{ margin: "4px 0" }} />
				<p>
					{t("emails.previewEmailRecipientsMessage", {
						count: email.initialRecipientsCount,
					})}
					:
				</p>
				<p>
					{t("emails.publishEmailForm.sendStrategy")}:{" "}
					{email.strategy === EmailSendStrategy.RoleBased
						? t("emails.publishEmailForm.roleBasedSelection")
						: t("emails.publishEmailForm.multiUserSelection")}
				</p>
				{email.strategy === EmailSendStrategy.RoleBased && (
					<>
						<p>
							{t("emails.publishEmailForm.recipientRole")}:{" "}
							{t("emails.roles." + email.recipientRole)}
						</p>
						{(email.faculties?.length ?? 0) > 0 && (
							<p>
								{t("emails.publishEmailForm.faculties")}:
								{email.faculties?.map(
									(f, index) =>
										(index === 0 ? " " : ", ") +
										(i18n.language === "ro" ? f.facultyNameRo : f.facultyNameEn)
								)}
							</p>
						)}
						{(email.departments?.length ?? 0) > 0 && (
							<p>
								{t("emails.publishEmailForm.departments")}:
								{email.departments?.map(
									(d, index) =>
										(index === 0 ? " " : ", ") +
										(i18n.language === "ro"
											? d.departmentNameRo
											: d.departmentNameEn)
								)}
							</p>
						)}
						{(email.studyPrograms?.length ?? 0) > 0 && (
							<p>
								{t("emails.publishEmailForm.studyPrograms")}:
								{email.studyPrograms?.map(
									(sp, index) => (index === 0 ? " " : ", ") + sp.name
								)}
							</p>
						)}
						{(email.years?.length ?? 0) > 0 && (
							<p>
								{t("emails.publishEmailForm.years")}:
								{email.years?.map(
									(y, index) =>
										(index === 0 ? " " : ", ") + t("emails.years." + y)
								)}
							</p>
						)}
					</>
				)}
			</div>
		</Modal>
	);
};
